__turbopack_context__.v({
  "className": "manrope_f3f6c18f-module__0i9Jka__className",
  "variable": "manrope_f3f6c18f-module__0i9Jka__variable",
});
